import { render, staticRenderFns } from "./tf.vue?vue&type=template&id=06cb988c&scoped=true"
import script from "./tf.vue?vue&type=script&lang=js"
export * from "./tf.vue?vue&type=script&lang=js"
import style0 from "./tf.vue?vue&type=style&index=0&id=06cb988c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cb988c",
  null
  
)

export default component.exports